import { Button } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledWrapperContent = styled.div`
  height: 465px;
  padding: 3.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  gap: 2.4rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: 2rem;
  }

  h2 {
    margin-bottom: 0;
  }
`;

export const StyledWrapperButtons = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex-wrap: wrap;
`;

export const StyledFeedbackButton = styled(Button)<{ $isPathway?: boolean }>`
  margin-bottom: 0;
  height: 24px;
`;

export const StyledNextRoomDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  img {
    width: 6rem;
    height: 6rem;
    margin-right: 0.2rem;
  }
`;

export const StyledNextRoomButton = styled.div`
  height: min-content;
  text-wrap: nowrap;
`;

export const StyledNextRoomContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: 1fr;

    a {
      width: fit-content;
    }
  }
`;

export const StyledRoomTitle = styled.p`
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  font-size: 1.8rem;
`;

export const StyledRoomDescription = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
`;

export const StyledSentFeedbackMsg = styled.div`
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  display: flex;
  color: ${({ theme }) => theme.colors.success.main};
  margin-bottom: 0;

  svg {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
  }
`;

export const StyledConfettiWrapper = styled.div`
  position: absolute;
  z-index: 9999;
  top: 0;
`;

export const StyledPathProgressWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;
  text-align: left;
  padding: 2.4rem 0;

  > p {
    margin-bottom: 1.6rem;
    color: ${({ theme }) => theme.colors.text.main};
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 4.6rem 0 2.4rem;

    > p {
      max-width: 450px;
      margin-bottom: 0;
    }
  }
`;

export const StyledProgressWrapper = styled.span`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  color: ${({ theme }) => theme.colors.text.main};

  > div {
    width: 6.5rem;
    height: 1rem;
    border-radius: 0.5rem;
    margin-left: 0.4rem;
    margin-top: 0.2rem;
    background-color: ${({ theme }) => theme.colors.grey[400]};

    > div {
      background-color: ${({ theme }) => theme.colors.info.secondary};
    }
  }

  > span {
    margin-left: 0.8rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    min-width: 14rem;
    justify-content: space-between;
  }
`;
